import {
  View,
  Text,
  StyleSheet,
  Animated,
  TouchableOpacity,
} from "react-native";
import React, { useRef, useState, useEffect } from "react";
import { shadowSm, primary, darkGreen } from "../../colors";
import MyText from "./MyText";
import { Fontisto, Entypo } from "@expo/vector-icons";
import translate from "../../functions/translate";

export default function SectionDropdown(props) {
  const animation = useRef(new Animated.Value(0)).current;
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(false);

  useEffect(() => {
    if (open) {
      Animated.timing(animation, {
        toValue: height,
        useNativeDriver: false,
        duration: 500,
      }).start();
    } else {
      Animated.timing(animation, {
        toValue: 0,
        useNativeDriver: false,
        duration: 500,
      }).start();
    }
  }, [open]);
  const iconRotate = animation.interpolate({
    inputRange: [0, height],
    outputRange: ["0deg", "180deg"],
  });
  return (
    <View
      style={{
        backgroundColor: props.backgroundColor,
        width: "100%",

        borderBottomLeftRadius: 15,
        borderBottomRightRadius: 15,
      }}
    >
      <Animated.View
        style={[styles.container, { height: animation }]}
        onLayout={props.onLayout !== undefined ? props.onLayout : null}
      >
        <View style={{ height: 500, padding: 10 }}>
          <View
            onLayout={(event) => {
              let { height } = event.nativeEvent.layout;
              setHeight(height + 20);
            }}
          >
            {props.children}
          </View>
        </View>
      </Animated.View>
      <TouchableOpacity onPress={() => setOpen(!open)} style={styles.header}>
        {props.icon}
        <MyText style={{ fontSize: 13, color: props.textColor }}>
          {open ? translate("close") : props.title}
        </MyText>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    overflow: "hidden",
  },
  header: {
    height: 50,
    padding: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});
